import { FlexCol } from '@/components/ui/flex';
import { FileText } from 'lucide-react';
import { memo } from 'react';

type DocumentViewerProps = {
  url?: string;
  name: string;
  mimeType: string;
};

function comparisonFunction(
  { url: prevUrl }: DocumentViewerProps,
  { url: nextUrl }: DocumentViewerProps
) {
  /**
   * TanstackQuery reloads on page focus, which causes the url to be resigned,
   * hence the url changes on every focus. This causes the PDFViewer to re-render.
   * To prevent this, we compare the urls without the query params.
   */
  const unsignedPrevUrl = prevUrl?.split('?')[0];
  const unsignedNextUrl = nextUrl?.split('?')[0];
  if (unsignedPrevUrl !== unsignedNextUrl) return false;
  return true;
}

const notSupportedMimeTypes = [
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/csv',
];

export const DocumentViewer = memo<DocumentViewerProps>(
  ({ url, name = '', mimeType }) => {
    if (notSupportedMimeTypes.includes(mimeType)) {
      return (
        <FlexCol h="full" justifyContent="center" alignItems="center" gap="4">
          <FileText size={64} className="text-secondary" />
          <p>This file type is not supported for preview</p>
          <p className="text-sm text-secondary">Download the file to view it</p>
        </FlexCol>
      );
    }

    return <iframe src={url} className="w-full flex-grow " title={name} />;
  },
  comparisonFunction
);
